import { useState } from 'react';
import { SbomToShare } from '../AssetsTable';

export const useShareState = () => {
  const [sbomsToShare, setSbomsToShare] = useState<SbomToShare[]>([]);
  return { sbomsToShare, setSbomsToShare };
};
